// extracted by mini-css-extract-plugin
export default {"navButton":"NavButton_navButton__UEM+r","active":"NavButton_active__VO4gC","label":"NavButton_label__Og5Il"};